import { Link } from 'react-router-dom';
import { categoryArticles, categoryMeta } from '@/mocks/articles';

interface CategoryCTASectionProps {
  slug: string;
}

export default function CategoryCTASection({ slug }: CategoryCTASectionProps) {
  const meta = categoryMeta[slug];
  const displayName = meta?.name || slug;

  return (
    <section className="relative w-full h-[340px] md:h-[400px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20flowing%20gradient%20with%20soft%20golden%20and%20amber%20tones%20modern%20minimal%20design%20subtle%20glow%20effect%20elegant%20atmosphere%20clean%20aesthetic%20warm%20color%20palette%20harmonious%20composition&width=1920&height=600&seq=category-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/35 to-black/50"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 text-center">
          更多{displayName}内容
        </h2>
        <p className="mt-3 text-sm text-background-50/70 text-center max-w-md">
          返回首页浏览更多精彩吃瓜内容
        </p>
        <Link
          to="/"
          className="mt-6 px-8 py-3 rounded-full bg-primary-500 text-background-50 font-bold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </section>
  );
}